<template>
  <div ref="root"><slot /></div>
</template>

<script>
export default {
  props: {
    do: {
      type: Function,
      required: true,
    },
  },
  methods: {
    listener(e) {
      if (this.$refs.root && (e.target === this.$refs.root || this.$refs.root.contains(e.target))) {
        return;
      }
      this.do();
    },
  },
  mounted() {
    document.addEventListener('click', this.listener);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.listener);
  },
};
</script>
